/**
 * Detect and parse Framelight X (FLX) embed URLs for Grass Valley / SCS player integration.
 */

/**
 * @param {string} url
 * @returns {boolean}
 */
export function isFlxUrl(url) {
    if (!url || typeof url !== "string") return false;

    try {
        const parsed = new URL(url);
        if (parsed.pathname.includes("/framelight/embed")) return true;
        if (
            parsed.hostname.includes("gvampp.com") &&
            parsed.searchParams.has("materialId")
        ) {
            return true;
        }
        return false;
    } catch {
        return false;
    }
}

/**
 * @param {string} url
 * @returns {{
 *   embedUrl: string,
 *   origin: string,
 *   playerBaseUrl: string,
 *   materialId: string,
 *   start: string|null,
 *   in: string|null,
 *   out: string|null
 * }}
 */
export function parseFlxUrl(url) {
    const parsed = new URL(url);
    const origin = parsed.origin;
    return {
        embedUrl: url,
        origin,
        playerBaseUrl: `${origin}/scs-standalone-player/`,
        materialId: parsed.searchParams.get("materialId") || "",
        start: parsed.searchParams.get("start"),
        in: parsed.searchParams.get("in"),
        out: parsed.searchParams.get("out"),
    };
}
